export const reportData = {
  scoupe: {
    acts: 'Акт',
    ttns: 'ТТН',
    tns: 'ТН',
    szvm: 'CЗВМ',
    payments: 'Оплата',
    notes: 'Заметка',
    dogovors: 'Договор',
    auto: 'Документы по авто',
    report: 'Отчет',
  },
  checkedScoupe: [
    'acts',
    'ttns',
    'tns',
    'szvm',
    'payments',
    'notes',
    'dogovors',
    'auto',
    'report',
  ],
  watermarks: {
    acts: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    ttns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
  },
  combine: {
    acts: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    ttns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    tns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    szvm: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    payments: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    notes: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    dogovors: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    auto: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
  },
}
export const loadDayData = {
  scoupe: {
    acts: 'Акт',
    ttns: 'ТТН',
    tns: 'ТН',
    szvm: 'CЗВМ',
    payments: 'Оплата',
    dogovors: 'Договор',
    auto: 'Документы по авто',
  },
  checkedScoupe: [
    'acts',
    'ttns',
    'tns',
    'szvm',
    'payments',
    'dogovors',
    'auto',
  ],
  watermarks: {
    acts: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    ttns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
  },
  combine: {
    acts: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    ttns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    tns: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    szvm: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    payments: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
    dogovors: [
      {
        value: 1,
        label: 'Да',
      },
      {
        value: 0,
        label: 'Нет',
      },
    ],
  },
}
